import { Product } from "@/types/types.ts";

export const FREE_DELIVERY_DMS_IDS = ["1", "14", "26", "155", "422"];

export const isEligibleForFreeDelivery = (product: Product) => {
  const availableOptions = product.fulfilmentOptions?.available ?? [];
  return availableOptions.some((option) =>
    FREE_DELIVERY_DMS_IDS.includes(option.aliases.dmsId),
  );
};
